interface ApiErrorResponse {
  message?: string;
}

interface AxiosErrorResponse {
  data?: ApiErrorResponse;
}

interface AxiosError {
  response?: AxiosErrorResponse;
  message?: string;
}

interface FormatXhrErrorOptions {
  error: AxiosError;
  errorPrefix: string;
}

export const formatXhrErrorMessage = ({
  errorPrefix,
  error,
}: FormatXhrErrorOptions): string => {
  let errorMessage = errorPrefix;

  if (error?.response?.data?.message) {
    errorMessage += ': ' + error.response.data.message;
  }
  return errorMessage;
};

export default {
  formatXhrErrorMessage,
};
